import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useControlReducer } from "../../../../controlContext";
import { useSource, useSourceReducer } from "../../../../sourceContext";
import { Button, Col, Form, Row } from "react-bootstrap";
import { dataSource } from "../../../../../../services/dataSource";
import { LANG_CATS, NAR, REC } from "../../../../../../shared/Data/typeDirs";
// import { EditDisplayNameButton } from "../editDisplayNameButton";
import { langTypeMap } from "../../../../../../shared/Data/langTypeMap";
import Language_v2 from "../../../../../../shared/Objects/language_v2";
import { LANG_ENTRY_TYPES } from "../../../../../../shared/Data/consts";

export function AddExistingItemForm({ name, show, idx }) {

  // const [controls] = useControl()
  const source = useSource()
  const sourceReducer = useSourceReducer()
  const controlReducer = useControlReducer()
  const [all, setAll] = useState({})
  // const [displayKeys, setDisplayKeys] = useState(['content'])
  const [filter, setFilter] = useState('')
  const [onlySelectedRels, setOnlySelectedRels] = useState(false)
  const [tagFilter, setTagFilter] = useState('All')
  const [loading, setLoading] = useState(false)
  // const parentKey = langTypeMap[name].getParentKey()
  // const defaultParentIndex = parentKey &&
  //   controls[parentKey] &&
  //   source[parentKey].findIndex(itm => itm._id === controls[parentKey])
  const addExisting = useCallback((sourceItem, subItem, typeDir) => {
    if (sourceItem) {
      controlReducer({ type: 'changed', name: typeDir, value: '', idx })
      return sourceReducer({ type: 'delete_item', typeDir, itemId: subItem._id })
    }
    let relatives = walkChildren(typeDir, subItem._id, all, true)
    let parent_type = langTypeMap[typeDir].getParentKey()
    let child = subItem
    let findFn = itm => itm._id === child[`_${parent_type}`]
    while (parent_type) {
      console.log('looping for parents', parent_type, child)
      let parent = all[parent_type].find(findFn)
      relatives[parent_type] = [parent]
      child = parent
      parent_type = langTypeMap[parent_type].getParentKey()
    }
    let itemsToAdd = {}
    console.log('got this newSource before adding existing item', relatives)
    for (let key in relatives) {
      const newItems = relatives[key].filter(chItm => (!source[key].find(srcItm => chItm._id === srcItm._id)))
      itemsToAdd[key] = itemsToAdd[key] ? [...itemsToAdd[key], newItems] : newItems
    }
    itemsToAdd[typeDir] = [subItem]
    console.log('ended up with this', itemsToAdd)
    sourceReducer({
      type: 'add_multiple_language_categories',
      entries: itemsToAdd
    })
  }, [sourceReducer, all, controlReducer, idx, source])

  const CheckboxList = useMemo(() => {
    if (loading === true || !show) return []
    return all[name] && all[name].reduce((acc, itm, accIdx) => {
      // console.log('mapping source to checks', type, item, itm )
      // let langEntryDisabled = false
      let disp = itm.getDisplayText(['content'])
      if ([NAR, REC].includes(name)) {
        let parentFullNum = all[langTypeMap[name].getParentKey()].find(parentItem => parentItem._id === itm[langTypeMap[name].getParentAddress()])
        parentFullNum = parentFullNum && parentFullNum.fullNumber
        disp = `${parentFullNum ? parentFullNum : 'No Parent in Language'}: ${disp}`
        // langEntryDisabled = true
      }
      if (shouldDisplayItem(itm, name, filter, tagFilter)) {
        let sourceItem = source[name].find(srcItm => srcItm._id === itm._id)
        // let parentItemExists = !!(sourceItem && langTypeMap[name].getParentKey()) ? !!source[langTypeMap[name].getParentKey()].find(par => par._id === sourceItem[langTypeMap[name].getParentAddress()]) : true
        if ((!onlySelectedRels || onlySelectedRels) && sourceItem) {
          acc.push(
            <Form.Check key={accIdx}>
              <Form.Check.Input
                type="checkbox"
                checked={sourceItem}
                onChange={() => addExisting(sourceItem, itm, name)} />
              <Form.Check.Label>{disp}</Form.Check.Label>
            </Form.Check>
          )
        }

      }
      return acc
    }, [])
  }, [filter, tagFilter, all, show, loading, onlySelectedRels, name, source, addExisting])
  // console.log('got new parent Key', controls[parentKey], defaultParentIndex, controls, parentKey, source[parentKey])

  useEffect(() => {

    if (Object.keys(all).length || show === false) return

    let timeout_id = setTimeout(async () => {
      let obj = {}
      for (let type of LANG_CATS) {
        obj[type] = await dataSource('remDb')[type].toArray()
      }
      obj[name] = obj[name].map(itm => new langTypeMap[name](itm))
      console.log('got all', obj, source)
      if (![NAR, REC].includes(name)) {
        Language_v2.sortCategories(obj, name)
      } else {
        Language_v2.sortLangEntries({ ...source, ...obj }, name)
      }
      obj = { ...all, ...obj }
      if(timeout_id) setAll(obj)

    })

    return ()=>{clearTimeout(timeout_id); timeout_id = null}
  }, [show, all, name, source])

  function textChange(evt) {
    setFilter(evt.target.value)
  }

  function selectAllFiltered() {
    setLoading(true)
    setTimeout(() => {
      let allFiltered = all[name].filter(itm => shouldDisplayItem(itm, name, filter, tagFilter))
      console.log("got all filtered", allFiltered)
      for (let itemToSelect of allFiltered) {
        let isItemSelected = source[name].find(srcItem => srcItem._id === itemToSelect._id)
        // console.log('does item already exist?', isItemSelected)
        if (!isItemSelected) {
          console.log('found missing item', itemToSelect)
          addExisting(false, itemToSelect, name)
        }
      }
      setLoading(false)
    })
  }

  function deselectAllFiltered() {
    setLoading(true)
    setTimeout(() => {
      let allFiltered = all[name].filter(itm => shouldDisplayItem(itm, name, filter, tagFilter))

      console.log("got all filtered", allFiltered)
      for (let itemToSelect of allFiltered) {
        let isItemSelected = source[name].find(srcItem => srcItem._id === itemToSelect._id)
        // console.log('does item already exist?', isItemSelected)
        if (isItemSelected) {
          console.log('found missing item', itemToSelect)
          addExisting(isItemSelected, itemToSelect, name)
        }
      }
      setLoading(false)
    })
  }




  // function getCheckboxList() {

  // }

  return (
    <>
      {/* <EditDisplayNameButton
        overlayDirection="bottom"
        name={name}
        setDisplayKeys={setDisplayKeys}
        displayKeys={displayKeys}
      /> */}
      <Form.Control type="text" placeholder="Filter Source Items" onChange={textChange} />
      {[NAR, REC].includes(name) ? (
        <Row>
          <Form.Label column sm="3">Language Entry Tag: </Form.Label>
          <Col sm="3">
            <Form.Control as="select" onChange={evt => setTagFilter(evt.target.value)}>
              <option value={'All'}>{'All'}</option>
              {LANG_ENTRY_TYPES.map((itm, idx) => <option key={idx} value={itm}>{itm}</option>)}
            </Form.Control>
          </Col>
          <Col sm="3">
            <Button variant="outline-secondary" onClick={() => selectAllFiltered()}>{'Select All Displayed'}</Button>
          </Col>
          <Col sm="3">
            <Button variant="outline-secondary" onClick={() => deselectAllFiltered()}>{'De-Select All Displayed'}</Button>
          </Col>
        </Row>
      ) : []}
      <Form.Check type="checkbox" label="Show Only Current Entries" onChange={() => setOnlySelectedRels(!onlySelectedRels)} />

      <Form.Group>
        {CheckboxList}

      </Form.Group>

    </>
  )

}

function shouldDisplayItem(itm, name, filter, tagFilter) {
  return itm.getDisplayText().toLowerCase().includes(filter.toLowerCase()) &&
    (![NAR, REC].includes(name) || tagFilter === 'All' || tagFilter === itm.tag)
}


function walkChildren(type, _id, source, addMatchOrMiss = false) {
  let childTypes = langTypeMap[type].getChildTypes()
  let newChildren = {}
  // console.log('looking for children with', { type, childTypes, _id, source, addMatchOrMiss })
  for (let childType of childTypes) {
    newChildren = { [childType]: [], ...newChildren }

    for (let subItem of source[childType]) {
      if (_id === subItem[langTypeMap[childType].getParentAddress()]) {
        // console.log('found child', childType, _id, subItem[langTypeMap[childType].getParentAddress()])
        if (addMatchOrMiss) newChildren[childType].push(subItem)
        let childRes = walkChildren(childType, subItem._id, { ...source }, addMatchOrMiss)
        for (let childResKey in childRes) {
          newChildren[childResKey] = newChildren[childResKey] || []
          newChildren[childResKey] = [...newChildren[childResKey], ...childRes[childResKey]]
        }
      } else {
        if (!addMatchOrMiss) newChildren[childType].push(subItem)
      }
    }
  }

  return Object.keys(newChildren)[0] && newChildren[Object.keys(newChildren)[0]].length ? {
    // ...source,
    ...newChildren
  } : {}

}